export const GITHUB_LINK = 'https://github.com/Singularity-DAO';
export const DISCORD_LINK = 'https://discord.gg/singularitydao';
export const TELEGRAM_LINK = 'https://t.me/Singularity_Fi';
export const TWITTER_LINK = 'https://x.com/Singularity_Fi';
export const MEDIUM_LINK = 'https://medium.com/singularitydao';
export const FACEBOOK_LINK = 'https://www.facebook.com/SingularityDAO';
export const INSTAGRAM_LINK = 'https://instagram.com/singularitydao';
